// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"4a0b198f","654":"63fd1077","709":"3fa51451"}[chunkId] + ".chunk.js";
};